<!-- WonderYjjRate.vue -->
<template>
	<div>
		<div class="row">
			<template v-if="days.length">
				<RatePlate v-for="(day, index) in days" :date1="day" :key="index" :plate_type=14
					:selectedPlateCode="selectedPlateCode" @plate-selected="handlePlateSelected">
				</RatePlate>
			</template>
		</div>
		<div class="row">
			<div class="col col-md-2 col-sm-3" v-if="selectedPlateCode">
				<PlateStockPopular :plate_type=14 :plate_code="selectedPlateCode" :p_date=selectedDate
					@p_show_kline="handleShowKline" @date-selected="handleDateSelected">
				</PlateStockPopular>
			</div>
			<div class="col col-md-10 col-sm-9">
				<StockKlineDay v-if="selectedPlateCode" :symbol_code="selectedPlateCode" :title="selectedPlateName" :subText="selectedPlateCode" :highlightDate="selectedDate" :chart_heigh="'400px'" :zoom_start=40></StockKlineDay>
				<StockMultiChart  v-if="symbol_code" :symbol_code="symbol_code" :symbol_name="symbol_name" :selectedDate="selectedDate" :chart_width="'900px'">
				</StockMultiChart>
			</div>
		</div>
	</div>
</template>

<script>
	import YjjMixin from '../../mixins/views/wonder/YjjMixin.js'

	export default {
		mixins: [YjjMixin]
	}
</script>

<style>
</style>